import { render, staticRenderFns } from "./LeadsAgent.vue?vue&type=template&id=123d0e64&scoped=true"
import script from "./LeadsAgent.vue?vue&type=script&lang=js"
export * from "./LeadsAgent.vue?vue&type=script&lang=js"
import style0 from "./LeadsAgent.vue?vue&type=style&index=0&id=123d0e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d0e64",
  null
  
)

export default component.exports